import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Texto_sitio } from "src/assets/text_site";

@Component({
  selector: 'app-metodos-pagos',
  templateUrl: './metodos-pagos.component.html',
  styleUrls: ['./metodos-pagos.component.scss'],
  standalone: true,
  providers: [Texto_sitio],
  imports: [
    CommonModule,
    TranslateModule
  ]
})
export class MetodosPagosComponent implements OnInit {
  todoElIdioma: any = {};
  lang: any;

  constructor(
    public activatedRoute: ActivatedRoute,
    private texto_sitio: Texto_sitio,
    private translateService: TranslateService
  ) {
    this.lang = this.translateService.currentLang;
    if (this.lang == "es") {
      this.todoElIdioma = this.texto_sitio.spain.medio_pago;
    } else {
      this.todoElIdioma = this.texto_sitio.english.medio_pago;
    }
   }

  ngOnInit(): void {
  }

}
